<template>
    <div class="liveChatContainer">
      <div class="imageContainer">
        <CustomerConnectedChannel :customer="customer" placement="sideBar" />
        <div class="customerNameContainer">
          <div :class="!crm && customer.count > 0 ? 'bold-text' : '' ">
            <div class="liveChatHeading">
              <div class="flex-start ion-align-items-center paddingBottom">
                <h2 v-if="customer.name && customer.name != 'unrecorded'" class="liveChatName ion-no-margin" :title="customer.name">{{ customer.name }}</h2>
                <h2 v-else class="liveChatName ion-no-margin" title="Anonymous">Anonymous</h2>

                <div class="flex-start ion-align-items-center optin-status-tag optin-nostatus" v-if="customer.marketing_opt_in_state === 0">
                  <img src="@/resources/images/marketing-optin-nostatus.svg" alt="no_status" class=""/>
                </div>
                <div class="flex-start ion-align-items-center optin-status-tag optin-subscribed" v-if="customer.marketing_opt_in_state === 1">
                  <img src="@/resources/images/marketing-optin-subscribed.svg" alt="subscribed" class=""/>
                </div>
                <div class="flex-start ion-align-items-center optin-status-tag optin-unsubscribed" v-if="customer.marketing_opt_in_state === -1">
                  <img src="@/resources/images/marketing-optin-unsubscribed.svg" alt="unsubscribed" class=""/>
                </div>
                
                <HelpTooltip 
                  v-if="(customer.platform == 'whatsapp' && String(customer?.channel_id) !== String(whatsAppSocialData?.id)) || (customer.platform == 'googlercs' && String(customer?.channel_id) !== String(googlercsSocialData?.id)) || (customer.platform == 'sms' && String(customer?.channel_id) !== String(smsSocialData?.id))" 
                  :iconImage="conversationDeletedIcon" 
                >
                  Conversation's Channel has been disconnected
                </HelpTooltip>
              </div>
            </div>
            
            <p v-if=" !crm && customer.lastReplyTimestamp != 'None' && customer.lastReplyTimestamp != null && customer.lastReplyTimestamp != ''" class="sub-title ion-no-margin">
              {{ renderDateTime_lastReplyTimestamp( customer.lastReplyTimestamp, "customReadable", false ) }}
            </p>

          </div>
        </div>  
      </div>
      <div class="singleCustomerModeTakeoverTypeIconArea custom_tooltip_container flex-container" v-if="!crm && (!customer.status || customer.status != 'invalid') && !customer.retarget" >
        <span v-if="!crm && customer.count > 0" class="tooltip_container">
          <div class="liveChatUnread" :class="customer.active == true && customer.assigned_to == null ? 'margin-bottom':''"> {{ customer.count }} </div>
        </span>
        <template v-if="!customer.retarget">
          <span v-if="customer.active && (isAdmin || !customer.assigned_to)" class="tooltip_container">
            <img src="@/resources/images/bot_active.svg" alt="bot_active" />
            <span class="custom_tooltip_text right">Bot is active</span>
          </span>
          <template v-else-if="!customer.active">
            <!-- added [customer.assigned_to.id == group_id] in below condition as a fallback because sometimes in pusher event data "assigned_to.agent_type" is not coming -->
            <span v-if="!customer.assigned_to || (customer.assigned_to?.id && (customer.assigned_to.agent_type === 'Group' || customer.assigned_to.id == group_id))" class="tooltip_container">
              <img src="@/resources/images/page-inbox-human-support.svg" alt="human_support" title="Requested an Agent" data-toggle="tooltip" data-placement="left" />
              <span class="tooltip_text left" style="width: 180px;">Requested an Agent</span>
            </span>
            <!-- removed [&& customer.assigned_to.agent_type === 'Agent'] from below condition as it's else case and we whatever goes there is considered an asigned to agent -->
            <span v-else-if="customer.assigned_to?.id" class="tooltip_container">
              <img v-if="customer.assigned_to.picture" :src="customer.assigned_to.picture" alt="customer_picture" title="name" data-toggle="tooltip" data-placement="left" />
              <div v-else class="botProfileImageInitialCharTextOnly" >
                {{ getNameInitials(customer.assigned_to.name) }}
              </div>
              <span class="tooltip_text left" style="width: 180px;">Assigned to {{ customer.assigned_to.name }}</span>
            </span>
          </template>
        </template>
      </div>
    </div>
    <div class="singleCustomerModeTakeoverTypeIconArea custom_tooltip_container" v-if="customer.status == 'invalid'" >
      <img
        src="@/resources/images/attention-sign.png"
        title="Conversation is invalid"
        data-toggle="tooltip"
        data-placement="left"
        alt="invalid"
      />
      <span class="custom_tooltip_text right">Conversation is invalid</span>
    </div>
</template>

<script>
import CustomerConnectedChannel from '/src/components/customerConnectedChannel.vue'
import { getNameInitials } from '/src/helpers/global.helpers.js';
import HelpTooltip from "/src/components/HelpTooltip.vue";
import conversationDeletedIcon from '@/resources/images/conversation_deleted.svg';
import { renderDateTime_lastReplyTimestamp } from '@/helpers/date.helpers';
import { useAuthStore } from '@/stores/auth';
import { useSocialChannels } from '@/composables/useSocialChannels';

export default {
  components: {
    CustomerConnectedChannel,
    HelpTooltip
  },
  data() {
    return {
      conversationDeletedIcon
    };
  },
  setup() {
    const { whatsAppSocialData, googlercsSocialData, smsSocialData } = useSocialChannels();
    return { whatsAppSocialData, googlercsSocialData, smsSocialData };
  },
  props: {
    customer: {
      type: Object,
    },
    crm: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    isAdmin() { return useAuthStore().isAdmin; },
    group_id() { return useAuthStore().authData?.group_id; },
  },
  methods: {
    getNameInitials,
    renderDateTime_lastReplyTimestamp,
  }
};
</script>

<style scoped>

.liveChatContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.liveChatName {
  font-size: 16px;
  line-height: 20px;
  color: var(--black);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  cursor: pointer;
  position: relative;
}
.liveChatName:hover::after {
  content: attr(title);
  position: absolute;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  padding: 5px 8px;
  border-radius: 4px;
  white-space: nowrap;
  left: 0;
  top: 100%;
  transform: translateY(5px);
  font-size: 12px;
  visibility: visible;
  opacity: 1;
}
.liveChatUnread {
  background-color: var(--purple);
  color: #ffffff;
  font-size: 14px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom_tooltip_container .custom_tooltip_text {
  width: 150px;
  font-size: 13px;
  background-color: #000;
  color: #fff;
  pointer-events: none;
  opacity: 0;
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  text-align: center;
  padding: 5px 5px;
  line-height: 1.5;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  position: absolute;
  z-index: 1;
  display: inline-block;
}

.custom_tooltip_container:hover .custom_tooltip_text {
  opacity: 1;
}

.custom_tooltip_container .custom_tooltip_text.left {
  /* top: -5px; */
  bottom: 0px;
  left: 105%;
}

.custom_tooltip_container .custom_tooltip_text.right {
  bottom: 0px;
  right: 136%;
}

.custom_tooltip_container .custom_tooltip_text.left::after {
  content: " ";
  position: absolute;
  /* top: 50%; */
  bottom: 10px;
  right: 100%; /* To the left of the tooltip */
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent #000 transparent transparent;
}

.custom_tooltip_container .custom_tooltip_text.right::after {
  content: " ";
  position: absolute;
  /* top: 50%; */
  bottom: 10px;
  left: 100%; /* To the right of the tooltip */
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent #000;
}
/* custom_tooltip_text related code end */
.tooltip_container .tooltip_text.left {
  position: absolute;
  z-index: 1;
  top: -14%;
  right: 136%;
}
.flex-container{
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
}
.customerNameContainer{
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.imageContainer{
  display: flex;
  align-items: center;
}
.margin-bottom{
  margin-bottom: 3px;
}
.optin-status-tag{
  padding: 3px;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}
.optin-status-tag.optin-nostatus{
  background-color: #EDEDED;
  color: #54575E;
}
.optin-status-tag.optin-subscribed{
  background-color: #EAFDF2;
  color: #2DD36F;
}
.optin-status-tag.optin-unsubscribed{
  background-color: #FEE3DD;
  color: #FA7554;
}
.optin-status-tag img{
  height: 14px;
  width: auto;
}
</style>
